import { ReactNode } from 'react';
import styled from 'styled-components';

const CardContainer = styled.div<{ popular: boolean }>`
  width: 23rem;
  position: relative;
  border-radius: 0.75rem;
  margin: 1rem;
  color: white;
  
  border: ${({ popular }) => (popular ? 2 : 0)}px solid;
  border-color: ${({ popular }) => (popular ? '#a936ab' : 'transparent')};

  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.01) 100%);
  overflow: hidden;
`;

const CardTitle = styled.p`
  font-size: ${({ theme }) => theme.fontSize.extraSmall};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  text-align: center;
  margin-top: 0;
  color: rgba(255, 255, 255, 0.75);
  z-index: 3;
  position: relative;
`;

const PriceTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  position: relative;
  width: 100%;
  flex-wrap: wrap;
  padding-left: 1rem;
  padding-right: 1rem;
`;

const Price = styled.span`
  font-size: 3rem;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  display: flex;
  word-break: break-word;
  flex-wrap: wrap;
  text-align: center;
  sup {
    align-self: flex-start;
  }
`;

const Duration = styled.span`
  font-size: ${({ theme }) => theme.fontSize.small};
  margin: 0.5rem;
  vertical-align: bottom;
  color: rgba(255, 255, 255, 0.75);
  align-self: flex-end;
`;

const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSize.small};
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 2rem;
  z-index: 3;
  position: relative;
`;

export const SubDescription = styled.p`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  z-index: 3;
  position: relative;
`;

const TrialInfo = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: ${({ theme }) => theme.fontSize.small};
  text-align: center;
  margin-bottom: 0;
  z-index: 3;
  position: relative;
`;

const Popular = styled.div`
  background-color: #a936ab;
  width: 100%;
  font-size: 10px;
  font-family: ${({ theme }) => theme.fontFamily.medium};
  letter-spacing: 1px;
  text-align: center;
  padding: 4px 0;
`;

const Background = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
`;

const Content = styled.div`
  padding: 25px 20px;
`;

export interface PlanProps {
  title: string;
  price: string;
  duration: 'year' | 'month';
  description: string;
  subDescription: string;
  trialInfo?: string;
  popular?: boolean;
  children?: ReactNode;
}

const Plan: React.FC<PlanProps> = ({
  title,
  price,
  duration,
  description,
  subDescription,
  popular = false,
  trialInfo,
  children,
}) => {
  return (
    <CardContainer popular={popular}>
      {popular && <Popular>SAVE 40%</Popular>}
      <Content>
        <CardTitle>{title}</CardTitle>
        <PriceTag>
          <Price>
            {price}
          </Price>
          <Duration>/{duration}</Duration>
        </PriceTag>
        {trialInfo && <TrialInfo>{trialInfo}</TrialInfo>}
        <Description>{description}</Description>
        {children}
        <SubDescription>{subDescription}</SubDescription>
      </Content>
      {popular && (
        <Background
          alt="background"
          src="https://cdn.brain.fm/images/pricing_cirlces_of_blur.webp"
        />
      )}
    </CardContainer>
  );
};

export default Plan;
